import cn from 'classnames';
import Container from 'components/container';
import FunnelCta from 'components/funnel/cta';
import PawLoader from 'components/paw-loader';
import { useCart } from 'contexts/cart';
import { useRouter } from 'next/router';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import styles from '../../checkout/confirm/confirm.module.css';
import { useSubscriptionFunnel } from '../state';

const StepConfirmation: React.FC = () => {
  const { petType, selectedCategories, subscriptionId, loading, isSingleProductPurchase } =
    useSubscriptionFunnel();

  const { resetCheckout } = useCart();
  const router = useRouter();

  /**
   * Prevent user from going back to update subscription progress.
   */
  React.useEffect(() => {
    history.pushState(null, '', document.URL);
    const event = (): Promise<boolean> => router.push('/account/subscriptions');
    window.addEventListener('popstate', event);
    return () => {
      window.removeEventListener('popstate', event);
    };
  }, [router, subscriptionId]);

  if (loading) {
    return (
      <div className="flex justify-center p-20">
        <PawLoader />
      </div>
    );
  }

  return (
    <div
      className="bg-other-white w-full lg:max-w-2xl lg:rounded-lg lg:shadow-lg"
      data-test="subscription-funnel-overview"
    >
      <Container>
        <video
          className={cn('mx-auto mb-4 h-auto w-full max-w-xs', styles.video)}
          autoPlay
          muted
          playsInline
        >
          <source type="video/mp4" src="/media/checkout_completed.mp4" />
        </video>
        <h1 className="text-primary-main pb-2 text-center text-lg leading-none font-black tracking-wide uppercase lg:text-2xl">
          <FormattedMessage id="checkout:confirm:header" />
        </h1>
        <p className="text-grey-700 mx-auto max-w-xl pb-3 text-center">
          <FormattedMessage id="subscription-funnel:confirmation:sub-header" />
        </p>

        <FunnelCta
          visible={(selectedCategories.length > 0 && petType !== null) || isSingleProductPurchase}
          onClick={() => {
            router.push(`/account/subscriptions`);
            resetCheckout();
          }}
          data-test="subscription-funnel-overview-button-to-checkout"
        >
          <FormattedMessage id="subscription-funnel:confirmation:cta" />
        </FunnelCta>
      </Container>
    </div>
  );
};

export default StepConfirmation;
